export type { FieldOption as FieldOptionNew } from './with-controlled-value-single-select-new';
export { default as withControlledValueSingleSelectNew } from './with-controlled-value-single-select-new';
